import React from "react";
import "./education.css";
import Nitte from "../../assets/nitte.png";
import ppc from "../../assets/ppc.png";
import st from "../../assets/st.png";

const Skills = () => {
  return (
    <section id="education">
      <span className="eduTitle">My Academic Details</span>
      <span className="eduDesc">
        Overview of my academic background. 
      </span>
      <div className="eduBars">
        <div className="eduBar">
          <img src={Nitte} alt="NMAMIT" className="eduBarImg" />
          <div className="eduBarText">
            <h2>B-Tech</h2>
            <p>
              NMAMIT, Nitte Information Science Engineering<br></br> CGPA: 9.65
            </p>
          </div>
        </div>
        <div className="eduBar">
          <img src={ppc} alt="ppc" className="eduBarImg" />
          <div className="eduBarText">
            <h2>PUC</h2>
            <p>
              PoornaPrajna Pre- university college, Udupi <br></br>Percentage:96.5%
            </p>
          </div>
        </div>
        <div className="eduBar">
          <img src={st} alt="St" className="eduBarImg" />
          <div className="eduBarText">
            <h2>SSLC</h2>
            <p>
              St Cecilys English Higher Primary School Udupi<br></br>Percentage:97.60%.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;
